import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";
import { Container, Row, Col, NavDropdown, Navbar, Nav, Breadcrumb, Table, Tabs, Tab } from 'react-bootstrap';
import { Initial } from 'react-initial'
import ReactPaginate from 'react-paginate';
import img2 from "../Login/img/logo.png"
import Sidebar from "../Components/Sidebar/Sidebar";
import Topbar from "../Components/Topbar/Topbar";
import { useDropzone } from 'react-dropzone';
import './style.css'
import { ToastContainer, toast } from 'react-toastify';
import config from "../config/config";
import axios from "axios";
import LoadingSpinner from "../Components/LoadingSpinner";
const Upload = () => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const [video, setVideo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      let ext = acceptedFiles[0].name.split('.')
      if (ext.length) {
        if (ext[ext.length - 1] !== 'csv') {
          setVideo([])
          toast.error(' files must be .csv')
        }
        else {
          setVideo(acceptedFiles)
        }
      }
      setVideo([...acceptedFiles]);
    }
  }, [acceptedFiles]);
  // console.log(acceptedFiles)

  const uploadFile = async () => {
    try {
      if (video.length > 0) {
        setIsLoading(true)
        const formData = new FormData();
        formData.append("file", video[0])
        let path = config.siteUrl;
        const response = await axios.post(path + '/classes/upload', formData, {
          headers: {
            'Content-Type': 'Application/json',
            'Accept': 'Application/json',
          }
        })
        const res = response.data;
        if (res?.status === 200) {
          setIsLoading(false)
          setVideo([])
          toast.success(res?.message)
          if (res?.data?.csv_url && res?.data?.csv_url != '') {
            window.open(res?.data?.csv_url, '_blank')
          }
          if (res?.data?.duplicate_csv_url && res?.data?.duplicate_csv_url != '') {
            window.open(res?.data?.duplicate_csv_url, '_blank')
          }
        }
        // console.log(response.data);
      } else {
        setIsLoading(false)

        toast.error('Please upload .csv file!')
      }
    } catch (error) {
      console.error(error);
    }
    // var token = localStorage.getItem('token');

    // console.log(formData)
    // let path = config.siteUrl;
    // console.log(path)
    // await axios.post(path + '/classes/upload', formData, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    //   },
    // })
    //   .then(async (response) => {
    //     console.log(response)
    //     // displaySuccess(t('Gift Card Deleted Successfully'));
    //     // getGiftCards()
    //   })
    //   .catch((error) => {
    //     console.log(error)
    //     // displayError(error, t);
    //   });
  };
 
  return (
    <>
      <div className="main-div">
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <div className="blue-back"></div>
        <Row className="w-100 m-auto">
          {/* <Col md={2}>
            <Sidebar />

          </Col> */}
          <Col md={12} className="right-pad">
            <div className="main-text">
              <Topbar />
              <div>

                <div className={'new-card'}>
                  <div className="show-input-form-inner-title">
                    <section className="dropzone-main">
                      <div {...getRootProps({ className: 'dropzone' })}>
                        <input
                          {...getInputProps()}
                          name="fileimg"
                          type="file"
                          accept=".csv"

                        />
                        <div className="dropzone-details">
                          <h2>Drag & drop files here</h2>
                          <p>
                            or browse files on your computer
                          </p>
                          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1262_19965)">
                              <path d="M63.3334 66.6667H20C9.58128 66.6729 0.903021 58.6796 0.054588 48.2954C-0.793845 37.9112 6.47179 28.6152 16.7534 26.9301C21.4857 18.5397 30.3671 13.3451 40 13.3332C46.0068 13.3105 51.8415 15.3377 56.54 19.0801C61.1537 22.7396 64.4337 27.8166 65.8734 33.5267C74.4864 34.8501 80.626 42.5851 79.9601 51.2737C79.2942 59.9623 72.0475 66.6713 63.3334 66.6667ZM40 20C32.7724 20.0086 26.109 23.9071 22.56 30.2034L21 33.0001L17.8367 33.5167C11.0043 34.6614 6.18674 40.8477 6.75076 47.7523C7.31477 54.6569 13.0725 59.9794 20 60.0001H63.3334C68.562 60.0054 72.9121 55.982 73.3141 50.7689C73.7161 45.5558 70.0343 40.913 64.8667 40.1167L60.4801 39.4501L59.4067 35.1434C57.191 26.2327 49.182 19.9832 40 20ZM44.8334 53.3334H35.1667V43.3334H26.6667L40 30.0001L53.3334 43.3334H44.8334V53.3334Z" fill="#999C9F" />
                            </g>
                            <defs>
                              <clipPath id="clip0_1262_19965">
                                <rect width="80" height="80" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <p>.csv files are supported</p>
                        </div>

                      </div>
                      <aside>
                        {video.map((e) => (
                          <>
                            <Row>
                              <Col md={8}>
                                <div className="file-name">
                                  {e?.path}
                                </div>
                              </Col>
                              <Col md={4}>
                                <div className="side-icon">
                                  <i class="fas fa-times-circle"
                                    onClick={() => {
                                      setVideo([])
                                    }}>
                                  </i>
                                </div>
                              </Col>
                            </Row>
                            {/* <ul>{e?.path}</ul> */}

                          </>
                        ))}
                      </aside>
                    </section>
                  </div>
                  <Row className="w-100 display-center mt-5">
                    <div className="btn-box" onClick={uploadFile}>
                      <div className="main-btn">
                        Submit
                      </div>
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </Col>
        </Row>

      </div>
    </>
  )
}
export default Upload

